import { useEffect } from "react";
import { useDebounce } from "~/hooks/useDebounce";
import { trackEvent } from "~/utils/monitoring";

// Emits a single Mixpanel/RUM event whenever the dataset tables view settles on a
// query. Debounces the raw search term so we track once per settled query rather
// than once per keystroke. `searched` distinguishes listing the full table set from
// running a text search; `query` is only present when a search was performed.
export const useTrackDatasetTablesViewed = (search: string, datasetId?: string) => {
  const debouncedSearch = useDebounce(search);

  useEffect(() => {
    const searched = debouncedSearch.trim().length > 0;
    trackEvent("dataset_tables_listed", {
      dataset_id: datasetId,
      searched,
    });
  }, [debouncedSearch, datasetId]);
};

export default useTrackDatasetTablesViewed;
